import type { ImeKeyEventLike } from "./imeComposition.types";

/**
 * Returns true if the key event belongs to IME composition.
 * True when `isComposing` is true or keyCode is 229.
 */
export function isImeComposingKeyEvent(e: ImeKeyEventLike): boolean {
	// keyCode is deprecated, but Safari fires compositionend before the confirming
	// Enter keydown (isComposing=false there), so keyCode 229 is needed as well.
	return e.isComposing || e.keyCode === 229;
}
